import { useState } from "react";
import { MdSearch } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  function handleNotification() {
    navigate("/notification");
  }

  const [search, setSearch] = useState("");
  return (
    <>
      <nav className="bg-white shadow-sm sticky w-full z-10 top-0 px-6">
        <div className="container mx-auto">
          <div className="flex justify-between items-center py-4">
            {/* <div>
              <img src="assets/Logo.png" alt="Celma_logo" />
            </div> */}
            <div className="flex items-center gap-1 w-3/5">
              <MdSearch size={30} className="text-[#A7A7A7]" />
              <input
                type="text"
                value={search}
                onChange={(ev) => setSearch(ev.target.value)}
                placeholder="Search..."
                className="w-full p-2 rounded-lg focus:outline-none focus:border-purple text-[#A7A7A7]"
              />
            </div>
            <div
              className="bg-[#EBEBEB] p-2 rounded-full cursor-pointer"
              onClick={handleNotification}
            >
              <img src="assets/mi_notification.png" alt="" />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
